import { useEffect, useState } from 'react';
import { useDeviceDetection } from '@/utils/device-detection';
import DesktopLandingPage from '@/pages/desktop-landing';

interface DeviceAwareWrapperProps {
  children: React.ReactNode;
  excludePaths?: string[];
}

export function DeviceAwareWrapper({
  children,
  excludePaths = [],
}: DeviceAwareWrapperProps) {
  const { isDesktop } = useDeviceDetection();
  const [shouldShowDesktopLanding, setShouldShowDesktopLanding] =
    useState(false);

  useEffect(() => {
    // Check if current path should be excluded from desktop redirect
    const currentPath = window.location.pathname;
    const isExcluded = excludePaths.some((path) =>
      currentPath.startsWith(path)
    );

    // Show desktop landing if on desktop and not on an excluded path
    setShouldShowDesktopLanding(isDesktop && !isExcluded);
  }, [isDesktop, excludePaths]);

  // Show desktop landing page for desktop users
  if (shouldShowDesktopLanding) {
    return <DesktopLandingPage />;
  }

  // Show the actual app for mobile users
  return <>{children}</>;
}
